import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Star } from 'lucide-react';
import { cn } from '@/lib/utils';

interface ConfidenceLevel {
  stars: number;
  label: string;
  percentage: number;
  count: number;
  color: string;
  starColor: string;
}

interface ConfidenceChartProps {
  confidenceLevels: ConfidenceLevel[];
}

export function ConfidenceChart({ confidenceLevels }: ConfidenceChartProps) {
  return (
    <Card className="border-border/50 bg-card text-center">
      <CardHeader className="pb-4">
        <div className="flex items-center justify-between">
          <div>
            <CardTitle className="flex items-center gap-2 text-lg font-semibold text-foreground">
              Confidence Levels
            </CardTitle>
            <p className="mt-1 text-sm text-muted-foreground">
              Track your mastery across all vocabulary words
            </p>
          </div>
        </div>
      </CardHeader>
      <CardContent className="space-y-4">
        {confidenceLevels.map((level) => (
          <div key={level.stars} className="group">
            <div className="mb-2 flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="flex gap-0.5">
                  {Array.from({ length: level.stars }).map((_, i) => (
                    <Star
                      key={i}
                      className={cn(
                        "h-4 w-4 transition-colors",
                        level.starColor
                      )}
                    />
                  ))}
                </div>
                <span className="text-sm font-medium text-foreground">
                  {level.label}
                </span>
              </div>
              <div className="flex items-center gap-3">
                <span className="text-sm font-medium text-muted-foreground">
                  {level.percentage}%
                </span>
                <span className="min-w-[60px] text-right text-sm font-semibold text-foreground">
                  {level.count} {level.count === 1 ? "word" : "words"}
                </span>
              </div>
            </div>
            <div className="h-2.5 overflow-hidden rounded-full bg-muted">
              <div
                className={cn(
                  "h-full rounded-full transition-all duration-500 ease-out",
                  level.color
                )}
                style={{ width: `${level.percentage}%` }}
              />
            </div>
          </div>
        ))}
      </CardContent>
    </Card>
  );
}